export class AlertDialogClasses {

    /**
     * Style applied to
     */
    static root = "ic3AlertDialog-root";

    /**
     * Style applied to
     */
    static formRoot = "ic3AlertDialog-formRoot";

    static message = "ic3AlertDialog-message";

    static warning = "ic3AlertDialog-warning";

}

export declare type AlertDialogClassKey = keyof AlertDialogClasses;

